import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { BottomSheetAction } from "types/general.types"
import { updateWishListViewMode } from "appRedux/slices/wishListSlice"
import { ITEM } from "constants/index"
import WishListSliderView from "components/templates/WishListSliderView"

type WishItemPageTemplateProps = {
  wishItems: WishItem[];
  moreButtonActions: BottomSheetAction[];
}

export default function WishItemPageTemplate(props: WishItemPageTemplateProps) {
  const { wishItems, moreButtonActions } = props

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateWishListViewMode(ITEM))
  }, [])

  return (
    <WishListSliderView
      list={structuredClone(wishItems)}
      moreButtonActions={moreButtonActions}
      showProgressBar={wishItems.length > 1}
    />
  )
}
